import * as types from './mutation-types'

export const legal = ({ commit }, payload) => {
    commit(types.FILES_LEGAL, payload)
}

export const credit = ({ commit }, payload) => {
    commit(types.FILES_CREDIT, payload)
}

export const project = ({ commit }, payload) => {
    commit(types.FILES_PROJECT, payload)
}

export const review = ({ commit }, payload) => {
    commit(types.FILES_REVIEW, payload)
}

export const order = ({ commit }, payload) => {
    commit(types.FILES_ORDER, payload)
}

export const reset = ({ commit }, payload) => {
    commit(types.FILES_RESET, payload)
}

export default {
    legal,
    credit,
    project,
    review,
    order,
    reset
}
